export default __webpack_public_path__ + "static/media/zambia.10c622fc.png";